// extracted by css-extract-rspack-plugin
export default {"text":"_c8317883","image":"_dc4e3c99","imageOverlay":"_c4b235e3","link":"_e17c933e","header":"_f1e47741","description":"_d25dfb98","cta":"_2b991108"};